export const FETCH_ALLERGENS = {
  START: 'START_FETCH_ALLERGENS',
  COMPLETE: 'COMPLETE_FETCH_ALLERGENS',
  FAIL: 'FAIL_FETCH_ALLERGENS',
  CLEANUP: 'CLEANUP_FETCH_ALLERGENS',
}

export const ADD_ALLERGEN = 'ADD_ALLERGEN'
export const RENAME_ALLERGEN = 'RENAME_ALLERGEN'
export const RESET_ALLERGEN_TREE = 'RESET_ALLERGEN_TREE'

export const SET_DATA_FOR_RENAMING_ALLERGEN = 'SET_DATA_FOR_RENAMING_ALLERGEN'

export const SET_IS_CURATION_ENABLED_ALLERGEN = {
  START: 'START_SET_IS_CURATION_ENABLED_ALLERGEN',
  COMPLETE: 'COMPLETE_SET_IS_CURATION_ENABLED_ALLERGEN',
  FAIL: 'FAIL_SET_IS_CURATION_ENABLED_ALLERGEN',
}

export const DELETE_ALLERGEN = {
  START: 'START_DELETE_ALLERGEN',
  COMPLETE: 'COMPLETE_DELETE_ALLERGEN',
  FAIL: 'FAIL_DELETE_ALLERGEN',
}

export const REPLACE_ALLERGEN = 'REPLACE_ALLERGEN'

export const SAVE_ALLERGENS = {
  START: 'START_SAVE_ALLERGENS',
  COMPLETE: 'COMPLETE_SAVE_ALLERGENS',
  FAIL: 'FAIL_SAVE_ALLERGENS',
}
